import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios'
import StorageKeys from 'constants/storage-keys'
import I18n from 'i18n/i18n'
import { cloneDeep, isUndefined } from 'lodash'
import { getDeviceId } from 'utils/cookie'
import visitorIdManager from 'utils/visitorIdManager'
import { crossStorageUtils } from 'utils/crossStorage'
// import queryString from 'query-string'

const serializeQuery: any = (params: any, prefix: any) => {
  const query = Object.keys(params).map((key) => {
    const value = params[key]

    if (params.constructor === Array) key = `${prefix}[]`
    else if (params.constructor === Object) key = prefix ? `${prefix}[${key}]` : key

    if (value === null || value === undefined) return `${key}=`
    else if (typeof value === 'object') return serializeQuery(value, key)
    else return `${key}=${encodeURIComponent(value)}`
  })

  return [].concat.apply([], query).join('&')
}

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    'Device-Type': 'Webapp',
    'Accept-Language': I18n.language,
    'Device-Id': getDeviceId(),
  },
  paramsSerializer: (params: any) => serializeQuery(params),
})

apiClient.interceptors.request.use((config: AxiosRequestConfig) => {
  const headers = cloneDeep(config.headers)
  let finalToken
  finalToken = localStorage.getItem(StorageKeys.ACCESS_TOKEN)
  const visitorId = visitorIdManager.getVisitorId() || ''
  if (headers) {
    if (!isUndefined(headers?.authorization)) {
      finalToken = headers?.authorization
      delete headers.authorization
    } else if (!isUndefined(headers?.Authorization)) {
      finalToken = headers?.Authorization
      delete headers.Authorization
    }
  }

  return {
    ...config,
    headers: {
      ...headers,
      'X-Visitor-Id': visitorId,
      ...(finalToken ? { authorization: finalToken } : {}),
    },
  }
})

apiClient.interceptors.response.use(
  (response: AxiosResponse) => {
    // const isTypeBlob = response.config.responseType === 'blob'
    // if (!isTypeBlob && response && response.data && typeof response.data === "object") {
    //   return { ...response.data, statusApi: response.status }
    // }
    // return { ...response, statusApi: response.status }
    return response
  },
  (error: AxiosError<any>) => {
    if (error.response) {
      const relativeUrl = error?.response?.config?.url || ''
      const baseUrl = window.location.origin
      const urlParams = new URL(relativeUrl, baseUrl)
      const isExcluded =
        urlParams.pathname === '/api/v3/service_areas/current_area' ||
        (urlParams.pathname === '/v1/booking-entry/bookings' && error.response.data?.code === 4030) ||
        urlParams.pathname === '/api/v3/batches' ||
        /^\/api\/v3\/customers\/bookings\/\d+$/.test(urlParams.pathname)
      if (error.response.status === 401 && !isExcluded) {
        crossStorageUtils.setAccessToken('')
        window.location.reload()
      }
    }

    return error?.response || error
  }
)

export default apiClient
